import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import { Grid } from '@mui/material'
import WelcomeCard from './components/WelcomeCard'
import TotalProjectCountCard from './components/TotalProjectCountCard'
import TotalProjectStatusCard from './components/TotalProjectStatusCard'
import HoursCard from './components/HoursCard'
import RPICard from './components/RPICard'
import TaskTable from './components/TaskTable'
import axios from 'axios'
import { BASE_URL } from '../Utils/Baseurl'
import { useLocation } from 'react-router-dom'


const EmployeeDashboard = () => {

    const location = useLocation();
    const { resourceId } = location.state || {};
    const [employeeData, setEmployeeData] = useState([]);

    const dashboardData = [
        {
            title: "Completed",
            count: employeeData?.task_status_summary?.completed,
            gradient: "linear-gradient(135deg, #646987 0%, #CDE1F1 100%)",
            textColor: "#fff"
        },
        {
            title: "In Progress",
            count: employeeData?.task_status_summary?.in_progress,
            gradient: "linear-gradient(135deg, #646987 0%, #CDE1F1 100%)",
            textColor: "#fff"
        },
        {
            title: "Not Started",
            count: employeeData?.task_status_summary?.not_started,
            gradient: "linear-gradient(135deg, #646987 0%, #CDE1F1 100%)",
            textColor: "#fff"
        },
        {
            title: "On Hold",
            count: employeeData?.task_status_summary?.hold,
            gradient: "linear-gradient(135deg, #646987 0%, #CDE1F1 100%)",
            textColor: "#fff"
        }
    ];

    useEffect(() => {
        const employeeId = sessionStorage.getItem("currentUser");
        const idToUse = employeeId || resourceId;

        if (idToUse) {
            fetchEmployeeData(idToUse);
        }
    }, [resourceId]);


    /**
     * Fetches the employee data from the API and updates the state with the retrieved data.
     * Retrieves the authentication token from session storage and includes it in the request headers.
     * Upon successful response, transforms the data to match the expected format and sets the employeeData state with the transformed data.
     * Logs any errors encountered during the fetch operation.
     */
    const fetchEmployeeData = async (id) => {
        try {
            const response = await axios.get(`${BASE_URL}api/employee-dashboard/${id}/`, {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            })

            setEmployeeData(response.data.data);

        } catch (error) {
            console.error("Error fetching employee data:", error);
        }
    }

    return (
        <DashboardLayout>
            <Grid container direction='row' spacing={1} p={1}>
                <Grid size={{ xs: 12, sm: 8 }}>
                    <Grid container direction='column' spacing={1}>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <WelcomeCard employeeData={employeeData} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Grid container direction='row' spacing={1}>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                    <TotalProjectCountCard employeeData={employeeData} />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 8 }}>
                                    <Grid container direction='row' spacing={1}>
                                        {dashboardData.map((card, index) => (
                                            <Grid key={index} size={{ xs: 12, sm: 6 }}>
                                                <TotalProjectStatusCard
                                                    title={card.title}
                                                    count={card.count}
                                                    gradient={card.gradient}
                                                    textColor={card.textColor}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <Grid container direction='column' spacing={1}>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <HoursCard employeeData={employeeData} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <RPICard employeeData={employeeData} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container direction='row' p={1}>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <TaskTable employeeData={employeeData} />
                </Grid>
            </Grid>
        </DashboardLayout>
    )
}

export default EmployeeDashboard



